import { CircularProgress } from "@material-ui/core";
import { useContext, useMemo, useState } from "react";
import MainContext from "../../context/main/mainContext";
import money from "../../utilities/money";

export default function StripeLinks({
  team, internalDemoTeam, stripeCustomer, invoice,
}) {
  const { isProd, downloadTeamQuote } = useContext(MainContext);
  const customerId = team?.stripeCustomer?.id || stripeCustomer?.id;
  const subscriptionId = team?.stripeSubscription?.split("%")[1];
  const stripeLinkToCustomer = isProd
    ? `https://dashboard.stripe.com/customers/${customerId}`
    : `https://dashboard.stripe.com/test/customers/${customerId}`;
  const stripeLinkToSubscription = isProd
    ? `https://dashboard.stripe.com/subscriptions/${subscriptionId}`
    : `https://dashboard.stripe.com/test/subscriptions/${subscriptionId}`;

  const stripeLinkToInvoice = isProd
    ? `https://dashboard.stripe.com/invoices/${invoice?.id}`
    : `https://dashboard.stripe.com/test/invoices/${invoice?.id}`;

  const [isLoading, setIsLoading] = useState(false);

  const handleDownloadQuote = async (event) => {
    setIsLoading(true);
    event.preventDefault();
    await downloadTeamQuote(team.id);
    setIsLoading(false);
  };

  return (
    <aside>
      <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6 flex flex-col gap-2">
        <h3 className="text-base font-semibold text-gray-900">Links</h3>
        {customerId && (
          <a
            href={stripeLinkToCustomer}
            target="_blank"
            rel="noreferrer"
            className="text-gray-700 flex self-start px-6 py-2.5 border border-gray-300 rounded-md"
          >
            Open Customer
          </a>
        )}
        {subscriptionId && (
          <a
            href={stripeLinkToSubscription}
            target="_blank"
            rel="noreferrer"
            className="text-gray-700 flex self-start px-6 py-2.5 border border-gray-300 rounded-md"
          >
            Open Subscription
          </a>
        )}
        {internalDemoTeam?.id ? (
          <button
            className="text-gray-700 flex self-start px-6 py-2.5 border border-gray-300 rounded-md w-60"
            onClick={handleDownloadQuote}
            disabled={isLoading}
          >
            {isLoading ? <CircularProgress size={15} color="gray" /> : "Download Latest Quote"}
          </button>
        ) : (
          <div className="text-gray-700 flex self-start px-6 py-2.5">
            Latest quote will show up here
          </div>
        )}

        {invoice?.id ? (
          <a
            href={stripeLinkToInvoice}
            className="text-gray-700 flex self-start px-6 py-2.5 border border-gray-300 rounded-md"
            target="_blank"
            rel="noreferrer"
          >
            Open Invoice ({money.formatDollars(money.centsToDollars(invoice.amount_due))})
          </a>
        ) : (
          <div className="text-gray-700 flex self-start px-6 py-2.5">
            Invoice link will show up here...
          </div>
        )}
      </div>
    </aside>
  );
}
